import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import { getAnalyticsMiddleware } from "./addToGlobalAnalyticsMiddleware.js";

const _data = {
	reducers: {},
	store: null,
};

function _makeStore(reducers) {
	_data.store = createStore(combineReducers(reducers),
		compose(
			applyMiddleware(thunk, getAnalyticsMiddleware),
			window.__REDUX_DEVTOOLS_EXTENSION__ ?
				window.__REDUX_DEVTOOLS_EXTENSION__({
					name: "GlobalStore",
					id: "GlobalStore",
				}) :
				(f) => f
		)
	);
}

function _updateStore(reducers) {
	_data.store.replaceReducer(combineReducers(reducers));
}

// external interface
export default function addToGlobalStore(reducers) {
	_data.reducers = {
		..._data.reducers,
		...reducers,
	};

	if (_data.store) {
		_updateStore(_data.reducers);
	} else {
		_makeStore(_data.reducers);
	}

	return _data.store;
}



// WEBPACK FOOTER //
// ./src/shared/redux/addToGlobalStore.js